import { render, staticRenderFns } from "./ChessPage.vue?vue&type=template&id=cb810fae"
import script from "./ChessPage.vue?vue&type=script&lang=js"
export * from "./ChessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports